const ChartIcon = ({ fill, className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18.3327 18.333H1.66602C1.32435 18.333 1.04102 18.0497 1.04102 17.708C1.04102 17.3663 1.32435 17.083 1.66602 17.083H18.3327C18.6744 17.083 18.9577 17.3663 18.9577 17.708C18.9577 18.0497 18.6744 18.333 18.3327 18.333Z"
        fill={fill || "#D1D5DB"}
      />
      <path
        d="M8.125 3.33366V18.3337H11.875V3.33366C11.875 2.41699 11.5 1.66699 10.375 1.66699H9.625C8.5 1.66699 8.125 2.41699 8.125 3.33366Z"
        fill={fill || "#D1D5DB"}
      />
      <path
        d="M2.5 8.33366V18.3337H5.83333V8.33366C5.83333 7.41699 5.5 6.66699 4.5 6.66699H3.83333C2.83333 6.66699 2.5 7.41699 2.5 8.33366Z"
        fill={fill || "#D1D5DB"}
      />
      <path
        d="M14.166 12.4997V18.333H17.4993V12.4997C17.4993 11.583 17.166 10.833 16.166 10.833H15.4993C14.4993 10.833 14.166 11.583 14.166 12.4997Z"
        fill={fill || "#D1D5DB"}
      />
    </svg>
  );
};

export default ChartIcon;
